import { defineStore } from 'pinia'
import axios from 'axios'
import { useLocalizationStore } from './LocalizationStore.js'
import { useRoute, useRouter } from 'vue-router'

export const useClicksendStore = defineStore('ClicksendStore', {
    state: () => {
        return {
            emailHistoryList: '',
            localizationStore: useLocalizationStore(),
            isCredentialValid: false,
            status: {
                'UNAUTHORIZED': 401
            },
            route: useRoute(),
            router: useRouter(),
        }
    },
    actions: {
        async fetchEmailHistory(nextPageUrl) {
            let $this = this;
            const route = this.router.resolve(
                {
                    name: 'email-history'
                }
            );
            let url = route.href;
            if (typeof nextPageUrl != 'undefined') {
                nextPageUrl = nextPageUrl.substring(nextPageUrl.indexOf('?'));
                url += nextPageUrl;
            }
            try {
                axios.get(
                    url
                ).then(function(response) {
                    if (
                        response.data.error == true
                        && 
                        response.data.data.http_code == $this.status.UNAUTHORIZED
                    ) {
                        $this.isCredentialValid = false;
                        toastr.error(
                            $this.localizationStore.translate("clicksend.credentials.wrong.error.message"),
                            'Error!'
                        );
                        return;
                    }
                    if (typeof nextPageUrl != 'undefined') {
                        let emailList = '';
                        emailList = $this.emailHistoryList.data;
                        $this.emailHistoryList = response.data.data;
                        $this.emailHistoryList.data = emailList.concat($this.emailHistoryList.data)
                    }
                    else {
                        $this.emailHistoryList = response.data.data;
                    }
                }).catch(function(error) {
                    toastr.error(error.response.data, 'Error!');
                });
            } catch (error) {
                console.log(error);
            }            
        },
    },
    getters: {
    },
})